import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../../home/components/Footer';

export default function PaversPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const openScheduler = () => {
    const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widget) widget.click();
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="cursor-pointer">
              <div className="text-2xl font-bold leading-tight text-[#2C2C2C]">RW Construction</div>
              <div className="text-sm leading-tight text-gray-600">Las Vegas LLC</div>
            </Link>
            <div className="hidden lg:flex items-center gap-8">
              <Link to="/" className="text-sm font-medium text-gray-700 hover:text-[#FF6B35] transition-colors cursor-pointer">Home</Link>
              <Link to="/services/pool-repair" className="text-sm font-medium text-gray-700 hover:text-[#FF6B35] transition-colors cursor-pointer">Pool Repair</Link>
              <Link to="/services/synthetic-grass" className="text-sm font-medium text-gray-700 hover:text-[#FF6B35] transition-colors cursor-pointer">Synthetic Grass</Link>
              <Link to="/services/pavers" className="text-sm font-medium text-[#FF6B35] transition-colors cursor-pointer">Pavers</Link>
              <button onClick={openScheduler} className="bg-[#FF6B35] text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#E55A2B] transition-colors whitespace-nowrap cursor-pointer">
                Get Free Estimate
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/aba11acdd365b06d2c6c000b6fc9030b.jpg"
            alt="Professional Paver Installation Las Vegas"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
        </div>
        <div className="relative z-10 container mx-auto px-4 text-center text-white">
          <div className="inline-flex items-center gap-2 bg-[#B8860B] px-4 py-2 rounded-full mb-6">
            <i className="ri-road-map-line text-white"></i>
            <span className="text-white text-sm font-semibold">Premium Hardscaping</span>
          </div>
          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Paver Installation &amp; Design in Las Vegas
          </h1>
          <p className="text-white/90 text-lg leading-relaxed mb-8">
            Transform your outdoor spaces with stunning paver installations. From elegant driveways to beautiful patios, we create durable, eye-catching hardscapes that enhance your property's value and curb appeal.
          </p>
          <div className="flex flex-wrap gap-4">
            <button
              onClick={openScheduler}
              className="inline-flex items-center gap-2 bg-[#B8860B] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#9A7209] transition-all hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
            >
              <i className="ri-calendar-schedule-line text-xl"></i>
              Get Free Design Consultation
            </button>
            <a
              href="tel:7025001790"
              className="inline-flex items-center gap-3 bg-white text-orange-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-2xl"></i>
              Call 702-500-1790
            </a>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-[#B8860B] text-sm font-semibold tracking-wider uppercase">Our Services</span>
            <h2 className="text-4xl font-bold text-[#2C2C2C] mt-3 mb-4">Paver Installation Services</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">We offer comprehensive paver services for residential and commercial properties throughout Las Vegas.</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { img: 'https://readdy.ai/api/search-image?query=Elegant%20paver%20driveway%20installation%20Las%20Vegas%20home%20interlocking%20stone%20pattern%20luxury%20residential%20curb%20appeal%20professional%20hardscape%20photography%20clean%20simple%20background&width=600&height=400&seq=paver-service-001&orientation=landscape', title: 'Driveway Pavers', desc: 'Durable, beautiful driveways that make a lasting first impression and withstand heavy vehicle traffic.' },
              { img: 'https://readdy.ai/api/search-image?query=Beautiful%20paver%20patio%20outdoor%20living%20space%20Las%20Vegas%20backyard%20elegant%20stone%20design%20fire%20pit%20area%20professional%20hardscape%20installation%20clean%20simple%20background&width=600&height=400&seq=paver-service-002&orientation=landscape', title: 'Patio Pavers', desc: 'Create stunning outdoor living spaces perfect for entertaining, relaxing, and enjoying the Las Vegas weather.' },
              { img: 'https://readdy.ai/api/search-image?query=Decorative%20paver%20walkway%20path%20through%20Las%20Vegas%20residential%20garden%20landscaping%20elegant%20stone%20design%20professional%20installation%20clean%20simple%20background&width=600&height=400&seq=paver-service-003&orientation=landscape', title: 'Walkways & Paths', desc: 'Elegant walkways that guide guests through your property while adding visual interest and safety.' },
              { img: 'https://readdy.ai/api/search-image?query=Paver%20pool%20deck%20installation%20Las%20Vegas%20backyard%20swimming%20pool%20surround%20non%20slip%20stone%20surface%20professional%20hardscape%20clean%20simple%20background&width=600&height=400&seq=paver-service-004&orientation=landscape', title: 'Pool Decks', desc: 'Non-slip, heat-resistant pool deck pavers that stay cool underfoot and complement your pool design.' },
              { img: 'https://readdy.ai/api/search-image?query=Outdoor%20kitchen%20paver%20flooring%20Las%20Vegas%20backyard%20BBQ%20area%20elegant%20stone%20hardscape%20professional%20installation%20clean%20simple%20background&width=600&height=400&seq=paver-service-005&orientation=landscape', title: 'Outdoor Kitchens', desc: 'Durable paver foundations for outdoor kitchens, BBQ areas, and entertainment spaces.' },
              { img: 'https://readdy.ai/api/search-image?query=Commercial%20paver%20installation%20Las%20Vegas%20business%20property%20entrance%20elegant%20stone%20hardscape%20professional%20design%20clean%20simple%20background&width=600&height=400&seq=paver-service-006&orientation=landscape', title: 'Commercial Pavers', desc: 'Professional paver installations for businesses, HOAs, and commercial properties.' },
            ].map((service, index) => (
              <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all group">
                <div className="h-48 overflow-hidden">
                  <img
                    src={service.img}
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#2C2C2C] mb-2">{service.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{service.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Paver Types */}
      <section className="py-20 bg-[#F8F6F3]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-[#B8860B] text-sm font-semibold tracking-wider uppercase">Materials</span>
            <h2 className="text-4xl font-bold text-[#2C2C2C] mt-3 mb-4">Paver Styles & Materials</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">Choose from a wide variety of paver styles, colors, and materials to match your vision.</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { title: 'Interlocking Pavers', desc: 'Versatile and durable with endless pattern options', icon: 'ri-layout-grid-line' },
              { title: 'Travertine', desc: 'Natural stone elegance with cool surface temperatures', icon: 'ri-stack-line' },
              { title: 'Concrete Pavers', desc: 'Cost-effective with wide color and texture choices', icon: 'ri-checkbox-blank-line' },
              { title: 'Brick Pavers', desc: 'Classic timeless appeal with exceptional durability', icon: 'ri-building-4-line' },
              { title: 'Flagstone', desc: 'Natural irregular shapes for organic aesthetics', icon: 'ri-shape-line' },
              { title: 'Porcelain Pavers', desc: 'Modern look with superior stain resistance', icon: 'ri-contrast-2-line' },
              { title: 'Cobblestone', desc: 'Old-world charm with unmatched character', icon: 'ri-circle-line' },
              { title: 'Permeable Pavers', desc: 'Eco-friendly drainage for sustainable landscapes', icon: 'ri-drop-line' },
            ].map((type, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 bg-[#B8860B]/10 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${type.icon} text-[#B8860B] text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-[#2C2C2C] mb-2">{type.title}</h3>
                <p className="text-gray-600 text-sm">{type.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="order-2 lg:order-1 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20paver%20installation%20team%20working%20on%20luxury%20Las%20Vegas%20home%20driveway%20skilled%20craftsmen%20laying%20interlocking%20stone%20pavers%20sunny%20day%20high%20quality%20construction%20photography%20clean%20simple%20background&width=600&height=700&seq=paver-team-001&orientation=portrait"
                alt="Professional Paver Installation Team Las Vegas"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="order-1 lg:order-2">
              <span className="text-[#B8860B] text-sm font-semibold tracking-wider uppercase">Why Choose Us</span>
              <h2 className="text-4xl font-bold text-[#2C2C2C] mt-3 mb-6">Expert Paver Installation</h2>
              <p className="text-gray-600 text-base leading-relaxed mb-8">
                With over 20 years of experience in Las Vegas hardscaping, we deliver exceptional craftsmanship and attention to detail on every project. Our team understands the unique challenges of desert installations.
              </p>
              <div className="space-y-4">
                {[
                  { title: 'Proper Base Preparation', desc: 'We ensure a solid foundation for lasting results' },
                  { title: 'Expert Pattern Design', desc: 'Custom layouts that enhance your property\'s aesthetics' },
                  { title: 'Quality Materials', desc: 'Premium pavers from trusted manufacturers' },
                  { title: 'Precise Installation', desc: 'Meticulous attention to leveling and spacing' },
                  { title: 'Proper Drainage', desc: 'Engineered slopes to prevent water pooling' },
                  { title: 'Sealed & Protected', desc: 'Professional sealing for long-term durability' },
                ].map((feature, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="w-8 h-8 bg-[#B8860B] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-[#2C2C2C]">{feature.title}</h4>
                      <p className="text-gray-600 text-sm">{feature.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              {/* Certifications */}
              <div className="mt-8 p-6 bg-[#F8F6F3] rounded-xl">
                <h3 className="text-[#2C2C2C] font-semibold mb-4">Our Certifications</h3>
                <div className="flex flex-wrap gap-3">
                  {[
                    'ICPI Certified',
                    'NCMA Member',
                    'Belgard Authorized',
                    'Tremron Certified',
                    'HCPA Member'
                  ].map((cert, index) => (
                    <div key={index} className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm">
                      <i className="ri-award-fill text-[#B8860B]"></i>
                      <span className="text-[#2C2C2C] text-sm">{cert}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-[#2C2C2C]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-[#B8860B] text-sm font-semibold tracking-wider uppercase">Our Process</span>
            <h2 className="text-4xl font-bold text-white mt-3 mb-4">How We Work</h2>
            <p className="text-white/70 max-w-2xl mx-auto">Our proven installation process ensures beautiful, long-lasting results.</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-6">
            {[
              { step: '1', title: 'Consultation', desc: 'Discuss your vision and goals' },
              { step: '2', title: 'Design', desc: 'Create custom layout plans' },
              { step: '3', title: 'Excavation', desc: 'Prepare and grade the area' },
              { step: '4', title: 'Base Work', desc: 'Install compacted base layers' },
              { step: '5', title: 'Installation', desc: 'Lay pavers with precision' },
              { step: '6', title: 'Finishing', desc: 'Joint sand and seal' },
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-14 h-14 bg-[#B8860B] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white text-xl font-bold">{item.step}</span>
                </div>
                <h3 className="text-base font-bold text-white mb-1">{item.title}</h3>
                <p className="text-white/60 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-[#B8860B] text-sm font-semibold tracking-wider uppercase">Portfolio</span>
            <h2 className="text-4xl font-bold text-[#2C2C2C] mt-3 mb-4">Recent Paver Projects</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">Browse our portfolio of stunning paver installations throughout Las Vegas.</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { img: 'https://readdy.ai/api/search-image?query=Completed%20luxury%20paver%20driveway%20installation%20Las%20Vegas%20home%20elegant%20herringbone%20pattern%20interlocking%20stone%20curb%20appeal%20professional%20photography%20clean%20background&width=600&height=450&seq=paver-gallery-001&orientation=landscape', title: 'Herringbone Driveway', location: 'Henderson, NV' },
              { img: 'https://readdy.ai/api/search-image?query=Beautiful%20travertine%20paver%20patio%20Las%20Vegas%20backyard%20outdoor%20living%20space%20fire%20pit%20seating%20area%20professional%20hardscape%20installation%20clean%20background&width=600&height=450&seq=paver-gallery-002&orientation=landscape', title: 'Travertine Patio', location: 'Summerlin, NV' },
              { img: 'https://readdy.ai/api/search-image?query=Elegant%20paver%20pool%20deck%20installation%20Las%20Vegas%20luxury%20home%20swimming%20pool%20surround%20non%20slip%20surface%20professional%20hardscape%20clean%20background&width=600&height=450&seq=paver-gallery-003&orientation=landscape', title: 'Pool Deck Renovation', location: 'Las Vegas, NV' },
            ].map((project, index) => (
              <div key={index} className="group cursor-pointer">
                <div className="rounded-2xl overflow-hidden mb-4 shadow-lg">
                  <img
                    src={project.img}
                    alt={project.title}
                    className="w-full h-64 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <h3 className="text-lg font-bold text-[#2C2C2C]">{project.title}</h3>
                <p className="text-gray-500 text-sm flex items-center gap-1">
                  <i className="ri-map-pin-line text-[#B8860B]"></i>
                  {project.location}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-[#F8F6F3]">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-[#B8860B] text-sm font-semibold tracking-wider uppercase">FAQ</span>
            <h2 className="text-4xl font-bold text-[#2C2C2C] mt-3 mb-4">Paver Questions</h2>
          </div>
          <div className="space-y-4">
            {[
              { q: 'How long do pavers last?', a: 'Quality pavers properly installed can last 25-50 years or more. They\'re more durable than poured concrete and can be easily repaired if individual pavers become damaged.' },
              { q: 'Are pavers better than concrete?', a: 'Pavers offer several advantages: they\'re more flexible (won\'t crack from ground movement), easier to repair, more visually appealing, and can increase property value more than plain concrete.' },
              { q: 'How long does paver installation take?', a: 'A typical driveway takes 3-5 days, while a patio may take 2-4 days. Larger or more complex projects may take longer. We\'ll provide a detailed timeline during your consultation.' },
              { q: 'Do pavers require maintenance?', a: 'Pavers are low-maintenance. We recommend occasional sweeping, rinsing, and resealing every 2-3 years to maintain their appearance and protect against stains.' },
            ].map((faq, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-sm">
                <h3 className="text-lg font-bold text-[#2C2C2C] mb-2">{faq.q}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-orange-500 to-red-500">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Ready to Transform Your Outdoor Space?</h2>
          <p className="text-white/90 text-lg mb-8">
            Get a free design consultation and estimate for your paver project today.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <button
              onClick={openScheduler}
              className="inline-flex items-center gap-2 bg-white text-[#B8860B] px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-100 transition-all hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
            >
              <i className="ri-calendar-schedule-line text-xl"></i>
              Get Free Consultation
            </button>
            <a
              href="tel:7025001790"
              className="inline-flex items-center gap-3 bg-white text-orange-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-2xl"></i>
              Call 702-500-1790 Today
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
